import React, { createContext, useContext } from 'react'
import ShopProduct from '@/models/shopProduct.ts'
import OrderItemKind from '@/models/orderItemKind.ts'

export interface ShopProductsActions {
  getProduct(id: string): ShopProduct | undefined
}

interface ShopProductsContext {
  products: Array<ShopProduct>
}

export const ShopProductsContext = createContext<ShopProductsContext & ShopProductsActions>({
  products: [],
  getProduct(): ShopProduct | undefined {
    return undefined
  }
})

export function ShopProductsProvider({ children }: { children: React.ReactNode }) {
  const shopProducts: Array<ShopProduct> = [
    {
      id: 'print-card',
      title: '25x QR-Code drucken',
      description: 'Wir drucken deine QR-Code Karten für dich auf dickem Papier und senden sie an dich.',
      imgSrc: '/shopAssets/wir-drucken-euer-kartendesign.jpg',
      minPrice: '29,00€',
      orderKind: OrderItemKind.EXTERNAL_LINK,
      externalLink: 'https://fridaysnap.de/produkt/qr-code-karten-design-drucken/?utm_source=drive&utm_medium=app&utm_campaign=shop',
    },
    {
      id: 'card-frame',
      title: '6x QR-Code Rahmen',
      description: 'Einen passenden Rahmen für deine Karten. Wir liefern in 6er Paketen.',
      imgSrc: '/shopAssets/fridaysnap-de-qrcode-in-rahmen-2.jpg',
      minPrice: '29,00€',
      orderKind: OrderItemKind.EXTERNAL_LINK,
      externalLink: 'https://fridaysnap.de/produkt/qr-code-rahmen-aufsteller/?utm_source=drive&utm_medium=app&utm_campaign=shop',
    },
    {
      id: 'storage-increase',
      title: 'Speicherdauer verlängern',
      description: 'Verlängere die Speicherdauer deiner Galerie um 12-24 Monate',
      imgSrc: '/shopAssets/clock-extension-time.webp',
      minPrice: '15,00€',
      orderKind: OrderItemKind.INTERNAL_LINK,
      externalLink: `storage`,
    },
    {
      id: OrderItemKind.PRIMITIVE_PHOTOBOOK,
      title: 'Fotobuch',
      description: 'Du musst lediglich die Bilder auswählen und wir erstellen ein Fotobuch für dich. Den Entwurf senden wir an dich und erst sobald du es bestätigst, wird es gedruckt.',
      imgSrc: '/shopAssets/photo-book-preview-2.jpeg',
      minPrice: '35,00€',
      orderKind: OrderItemKind.PRIMITIVE_PHOTOBOOK,
    },
  ]

  const getProduct = (id: string) => {
    return shopProducts.find(product => product.id === id)
  }

  return <ShopProductsContext.Provider value={{
    products: shopProducts,
    getProduct,
  }}>
    { children }
  </ShopProductsContext.Provider>
}

export function useShopProducts() {
  return useContext(ShopProductsContext)
}
